import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const RelationshipTypesModelSchema = z
  .object({
    id: z.string(),
    type: z.string().nullish()
  })
  .strict()

export const RelationshipTypesModelFields = makeFieldKeys(RelationshipTypesModelSchema)

export type RelationshipTypesModel = z.infer<typeof RelationshipTypesModelSchema>

function validateRelationshipTypesModel(data: unknown): RelationshipTypesModel {
  try {
    return validateWithZodSchema(RelationshipTypesModelSchema, data, 'relationship types model')
  } catch (error) {
    throw new Error(`Relationship types model validation failed: ${error}`)
  }
}
